export default __webpack_public_path__ + "static/media/EnerG-icon.29c1aed0.png";